<template>
  <div>
    <navigation />
    <div class="p-grid datatable-container">
      <div class="p-sm-12">
        <DataTable
          :v-if="isLoaded"
          :value="usersInfo"
          :paginator="true"
          :rows="10"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 20, 30]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          dataKey="id"
          :scrollable="true"
          :selection.sync="selectedUsers"
          scrollHeight="400px"
          :resizableColumns="true"
          columnResizeMode="expand"
          :filters="filters"
          @row-select="onRowSelect"
          @row-unselect="onRowUnSelect"
        >
          <template #header>
            <div>
              <div class="p-grid p-ai-center vertical-container">
                <div class="p-sm-2">List of Users</div>
                <div class="p-sm-offset-8 p-sm-2">
                  <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText
                      placeholder="Global Search"
                      v-model="filters['global']"
                    />
                  </span>
                </div>
              </div>
            </div>
          </template>
          <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
          <Column
            v-for="col of columns"
            :field="col.field"
            :header="col.header"
            :key="col.field"
            sortable
          ></Column>
        </DataTable>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-sm-offset-8 p-sm-2">
        <button
          class="button"
          @click="handleApproveButtonClick"
          :disabled="isDisabled"
          v-if="isLoaded"
        >
          Approve Selected Users
        </button>
      </div>
      <div class="p-sm-2">
        <button
          v-if="isLoaded"
          class="button"
          @click="handleRefuseButtonClick"
          :disabled="isDisabled"
        >
          Inactive Selected Users
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import "primeflex/primeflex.css";
import swal from "sweetalert";
import http from "../../http-common";
import navigation from "../helperComponents/menu.vue";

export default {
  name: "approveUser",
  data() {
    return {
      usersInfo: [],
      selectedUsers: null,
      isLoaded: false,
      filters: {},
      userID: [],
      isDisabled: true,
      apiUrlPath: "api/users",
    };
  },
  components: {
    DataTable,
    Column,
    navigation,
    InputText,
  },
  methods: {
    /* eslint-disable no-console */
    retrieveUsers() {
      http
        .get(`${this.apiUrlPath}/all-users`)
        .then((response) => {
          this.usersInfo = response.data;
          this.isLoaded = true;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    onRowSelect(e) {
      this.userID.push(e.data.id);
      if (this.userID.length > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    onRowUnSelect(e) {
      let removeElement = this.userID.indexOf(e.data.id);
      this.userID.splice(removeElement, 1);
      if (this.userID.length > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    handleApproveButtonClick() {
      http
        .put(`${this.apiUrlPath}/approve-users/${this.userID}`)
        .then((res) => {
          if (res.status == 200) {
            swal(
              "User Successfully Set to Active",
              "Status: Active",
              "success"
            );
            this.retrieveUsers();
          } else {
            swal("Could Not Approve the User", "", "error");
          }
        });
    },
    handleRefuseButtonClick() {
      http.put(`${this.apiUrlPath}/refuse-users/${this.userID}`).then((res) => {
        if (res.status == 200) {
          swal(
            "User Successfully Set to Inactive",
            "Status: Inactive",
            "success"
          );
          this.retrieveUsers();
        } else {
          swal("Could Not Inactive the User", "", "error");
        }
      });
    },
  },
  created() {
    this.retrieveUsers();
    this.columns = [
      { field: "id", header: "ID" },
      { field: "username", header: "Username" },
      { field: "user_email", header: "User Email" },
      { field: "team", header: "Team" },
      { field: "role", header: "Role" },
      { field: "status", header: "Status" },
    ];
  },
};
</script>
<style>
.p-datatable-header {
  padding-top: 7px !important;
  padding-bottom: 7px !important;
  height: 49px !important;
}
</style>
